<template>
    <of-dialog
        :title="formTitle"
        @onCancel="cancel"
        @onConfirm="confirm"
        :width="width"
    >
        <div slot="content">
            <el-form
                ref="form"
                label-width="150px"
                :model="dataForm"
                :rules="editFormRules"
            >
                <el-form-item label="标题：" prop="Title">
                    <el-input
                        placeholder="请输入标题"
                        v-model="dataForm.Title"
                        clearable
                        maxlength="50"
                    ></el-input>
                </el-form-item>
                <el-form-item label="描述：">
                    <el-input
                        placeholder="请输入描述"
                        v-model="dataForm.Desc"
                        clearable
                        maxlength="50"
                    ></el-input>
                </el-form-item>
                <el-form-item label="上传图标：" prop="Icon">
                    <p>支持png/jpg/jpeg格式，建议尺寸78*78</p>
                    <of-upload
                        class="upload-demo"
                        list-type="picture-card"
                        @onPreview="onPreview"
                        @onRemove="onRemove"
                        @onUpLoad="onUpLoad"
                        @onExceed="onExceed"
                        :limit="1"
                        :fileList="pictureList"
                        :class="{ hidePic: hideUploadEdit }"
                        accept="image/jpeg, image/gif, image/png, image/jpg"
                    >
                        <div slot="content" >
                        <i slot="default" class="el-icon-plus"></i>
                        </div>
                    </of-upload>
                    <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
                        <img width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                </el-form-item>
                <el-form-item label="模块颜色：">
                    <el-color-picker v-model="dataForm.BackColor"></el-color-picker>
                </el-form-item>
                <el-form-item label="阴影颜色：">
                    <el-color-picker v-model="dataForm.ShadowColor"></el-color-picker>
                </el-form-item>
                <el-form-item label="页面属性：">
                    <el-select v-model="dataForm.PageType" placeholder="请选择" @change="changePayType">
                        <el-option
                        v-for="item in PageTypeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="二维码：" v-if="dataForm.PageType === 1" prop="QrCode">
                    <p>支持png/jpg/jpeg格式，建议尺寸78*78</p>
                    <of-upload
                        class="upload-demo"
                        list-type="picture-card"
                        @onPreview="onPreviewQrCode"
                        @onRemove="onRemoveQrCode"
                        @onUpLoad="onUpLoadQrCode"
                        @onExceed="onExceed"
                        :limit="1"
                        :fileList="qrCodeList"
                        :class="{ hideQrCode: hideUploadQrCode }"
                        accept="image/jpeg, image/gif, image/png, image/jpg"
                    >
                        <div slot="content" >
                        <i slot="default" class="el-icon-plus"></i>
                        </div>
                    </of-upload>
                    <el-dialog :visible.sync="dialogQrCodeVisible" :append-to-body="true">
                        <img width="100%" :src="dialogQrCodeUrl" alt />
                    </el-dialog>
                </el-form-item>
                <el-form-item label="二维码描述" v-if="dataForm.PageType === 1" prop="QrCodeStr">
                    <el-input
                        placeholder="请输入描述"
                        v-model="dataForm.QrCodeStr"
                        clearable
                        maxlength="30"
                    ></el-input>
                </el-form-item>
                <el-form-item label="链接：" prop="Url" v-if="dataForm.PageType === 2 || dataForm.PageType === 3">
                    <el-input
                        placeholder="请输入链接"
                        v-model="dataForm.Url"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item label="布局格式：">
                    <el-select v-model="dataForm.Type" placeholder="请选择">
                        <el-option
                        v-for="item in TypeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序号：" prop="Sort">
                    <el-input-number v-model="dataForm.Sort" :min="0" :max="100" size="small"></el-input-number>
                </el-form-item>
            </el-form>
        </div>
    </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import api from "@/modules/zjrc/api";
export default {
    name: "edit",
    props: {
        dataForm: {
            type: Object,
            default: null
        },
        formTitle: {
            type: String,
            default: ""
        }
    },
    components: {
        OfDialog,
        OfUpload
    },
    data() {
        var checkIcon = (rule, value, callback) => {
            let vm = this
            if (!value) {
                return callback(new Error("请上传图标"));
            }
            else{
                if(!vm.dataForm.Icon){
                    return callback(new Error("请上传图标"));
                }
            }
            callback();
        };
        var checkQrCode = (rule, value, callback) => {
            let vm = this
            if (!value) {
                return callback(new Error("请上传二维码"));
            }
            else{
                if(!vm.dataForm.QrCode){
                    return callback(new Error("请上传二维码"));
                }
            }
            callback();
        };
        return {
            isConfirm: false,
            width: "50%",
            addre: {
                province: "",
                city: "",
                area: "",
                town: "",
            },
            editFormRules: {
                QrCode: [
                    {
                        required: true,
                        validator: checkQrCode,
                        trigger: "change",
                    }
                ],
                Icon: [
                    {
                        required: true,
                        validator: checkIcon,
                        trigger: "change",
                    }
                ],
                Title: [
                    {
                        required: true,
                        message: '标题不能为空',
                        trigger: 'blur'
                    }
                ],
                Url: [
                    {
                        required: true,
                        message: '链接不能为空',
                        trigger: 'blur'
                    }
                ],
                QrCodeStr: [
                    {
                        required: true,
                        message: '描述不能为空',
                        trigger: 'blur'
                    }
                ]
            },
            hideUploadEdit: false,
            pictureList: [],
            dialogImageUrl: '',
            dialogVisible: false,
            limitNum: 1,
            PageTypeOption: [
                {label: '二维码',value: 1},
                {label: '内部链接', value: 2},
                {label: '外部链接',value: 3}
            ],
            qrCodeList: [],
            hideUploadQrCode: false,
            dialogQrCodeUrl: '',
            dialogQrCodeVisible: false,
            TypeOption: [
                {label: '一块',value: 1},
                {label: '二块', value: 2}
            ],
        }
    },
    mounted() {
        this.getImg()
        this.getQrCode()
    },
    methods: {
        changePayType() {
            this.$refs.form.clearValidate();
        },
        getImg() {
            if (
                this.dataForm.Icon === undefined ||
                this.dataForm.Icon === null ||
                this.dataForm.Icon == ""
            ) {
                return;
            }
            this.hideUploadEdit = true
            let picture = {
                url: this.dataForm.Icon
            }
            this.pictureList.push(picture)
        },
        getQrCode() {
            let vm = this
            if(vm.dataForm.PageType === 1) {
                if (vm.dataForm.QrCode === undefined || vm.dataForm.QrCode === null || vm.dataForm.QrCode === "") {
                    return false
                }
                vm.hideUploadQrCode = true
                let picture = {
                    url: vm.dataForm.QrCode
                }
                vm.qrCodeList.push(picture)
            }
        },
        //取消
        cancel() {
            this.$emit("formCallBack", null);
        },
        confirm() {
            let vm = this
            vm.$refs.form.validate(valid => {
                if (valid) {
                    vm.isConfirm = true
                    let param = Object.assign({},vm.dataForm)
                    api.SaveHomeSetting(param).then(res => {
                        vm.isConfirm = false
                        if (res.data.Code === 0) {
                            vm.$message({
                                message: '提交成功',
                                type: 'success'
                            })
                            vm.$emit("formCallBack", param);
                        } else {
                            this.$message({
                                message: res.data.Message,
                                type: "error"
                            });
                        }
                    }).catch(e => {
                        this.isConfirm = false;
                        this.$message({
                            message: e.toString(),
                            type: "error"
                        });
                    });
                }
            })
        },
        //查看图片
        onPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        //删除封面图
        onRemove() {
            this.pictureList = [];
            this.dataForm.Icon = null;
            this.hideUploadEdit = false;
        },
        //上传封面图
        onUpLoad(file) {
            if (file.response.Code === 0) {
                this.dataForm.Icon = '/files' + file.response.Data.StorePath;
                this.$message({
                    message: "图片上传成功",
                    type: "success",
                });
                this.hideUploadEdit = true;
            }
        },
        //查看图片
        onPreviewQrCode(file) {
            this.dialogQrCodeUrl = file.url;
            this.dialogQrCodeVisible = true;
        },
        //删除封面图
        onRemoveQrCode() {
            this.qrCodeList = [];
            this.dataForm.QrCode = null;
            this.hideUploadQrCode = false;
        },
        //上传封面图
        onUpLoadQrCode(file) {
            if (file.response.Code === 0) {
                this.dataForm.QrCode = '/files' + file.response.Data.StorePath;
                this.$message({
                    message: "图片上传成功",
                    type: "success",
                });
                this.hideUploadQrCode = true;
            }
        },
        onExceed() {
            this.$message({
                message: `只能选择 ${this.limitNum} 个文件`,
                type: "error",
            });
        },
    }
}
</script>
<style scoped lang="scss">
/deep/ .upload-demo  .el-upload input[type="file"] {
  display: none !important;
}

/deep/ .hidePic .el-upload--picture-card {
    display: none;
}

/deep/ .hideQrCode .el-upload--picture-card {
    display: none;
}
</style>
